<!--<div class="row">
    <div class="col-lg-10 px-0">-->
       
        <div class="row">
               
                <div class="col-lg-4">
                <small>Etichetta</small>
                <div class="input-group input-group-sm">
                    <input class="form-control form-control-sm"  name="{{j}}_{{i}}_label"  type="text" [(ngModel)]="f.label" />
                    <div class="input-group-append input-group-append-sm">
                            <select class="form-control form-control-sm"  name="{{j}}_{{i}}_show_label" [(ngModel)]="f.show_label">
                            <option [ngValue]="0">Nascondi</option>
                            <option [ngValue]="1">Mostra</option>
                        </select>                                              
                    </div>
                </div>
            </div>
            <div class="col-lg-4">
                <small>Nome campo</small>
                <div class="input-group input-group-sm">
                    <input class="form-control form-control-sm" maxlength="64" type="text" name="{{j}}_{{i}}_name" [(ngModel)]="f.name" (blur)="f.name==''?renameField(f):''">
                    <div class="input-group-append input-group-append-sm">
                        <button class="btn btn-sm btn-default" title="Suggerisci/Correggi nome sezione" (click)="renameField(f)"><i class="fas fa-magic"></i></button>
                    </div>
                </div>
            </div>
            <div class="col-lg-4">
                <small>Tipologia</small>
                <select class="form-control form-control-sm" name="{{j}}_{{i}}_type" [(ngModel)]="f.type" (change)="f.params='';suggestParams(f)">
                    <option value="text">Testo</option>
                    <option value="textarea">Area di testo</option>
                    <option value="number">Numero</option>
                    <option value="currency">Valuta</option>
                    <option value="date">Data</option>
                    <option value="time">Orario</option>
                    <option value="boolean">Sì/No</option>
                    <option value="select">Casella di riepilogo</option>
                    <option value="checkbox">Casella di controllo</option>
                    <option value="file">File</option>
                    <!--<option value="section">Sezione</option>-->
                    <option value="photo">Immagine</option>
                    <option value="formula">Formula</option>
                    <option value="address">Anagrafica</option>
                    <option value="document">Documento</option>
                    <option value="table">Tabella</option>
                    <option value="separator">Separatore</option>
                </select>
            </div>                                           
        </div>
        <div class="row" [class.collapse]="!f['expand']">
            <div class="col-12">
                <small>Descrizione estesa</small>
                <textarea class="form-control form-control-sm" rows="1" onfocus="this.rows=3;" name="{{j}}_{{i}}_description" [(ngModel)]="f.description"></textarea>
            </div>
                <div class="col-lg-2">                                                
                <small>Obbligatorio</small>
                <select class="form-control form-control-sm" name="{{j}}_{{i}}_required" [(ngModel)]="f.required">
                    <option selected [ngValue]="0">No</option>
                    <option [ngValue]="1">Si</option>
                </select>
            </div>
            <div class="col-10">
                <small>Valore di default</small>
                <input type="text" class="form-control form-control-sm"  name="{{j}}_{{i}}_defaultvalue" [(ngModel)]="f.defaultvalue" />
                <small *ngIf="f.type=='date'">                                
                    <small class="text-primary mb-2">
                        <i class="fa fa-info-circle mr-1"></i>
                        <i>Inserire una formula per il calcolo automatico del tipo:</i><br/>
                        new Date('<b>{{typeCode('nomecampo data')}}</b>').setDate(new Date('<b>{{typeCode('nomecampo data')}}</b>').getDate() + <b>{{typeCode('nomecampo giorni')}}</b>)<br>
                    </small>
                </small>
                <small *ngIf="f.type=='formula'">
                    <small class="text-primary mb-2">
                        <i class="fa fa-info-circle mr-1"></i>
                        <i>Inserire una formula che verrà calcolata con linguaggio Javascript. I riferimenti ai campi del form potranno essere scritti come </i> <b>{{typeCode('nomecampo')}}</b><br>
                        FUNZIONI SPECIALI:<br/>
                        <b>$SUMTABLE</b>(nome tabella,nome del campo tabella da sommare)<br>
                        <b>$AVERAGETABLE</b>(nome tabella,nome del campo tabella su cui effettuare la media)<br>
                    </small>
                </small>
                <small *ngIf="f.type=='select'">
                    <small class="text-primary mb-2">
                        <i class="fa fa-info-circle mr-1"></i>
                        <i>
                            FUNZIONI SPECIALI:<br/>
                            <b>usare la funzione <pre>sql(sql_string)</pre> per ottenere i dati dal database. Verrà considerata la prima colonna della lista restituita</b><br/>
                            <b>usare la funzione <pre>localdatabase()</pre> per memorizzare valori direttamente dal form </b>    
                        </i>
                    </small>
                </small>
            </div>                                                                                                                    
            <ng-container [ngSwitch]="f.type">
                <div class="col-12" *ngSwitchCase="'select'">
                    <small>Valori della lista</small>
                    <ng-container *ngIf="isArray(f.params)">                                               
                        <select class="form-control form-control-sm"  multiple="multiple" [(ngModel)]="param_selected">                                                    
                            <option *ngFor="let s of f.params" value="{{s}}">{{s}}</option>
                        </select>
                    </ng-container>     
                    <div class="text-right pt-1">
                        <button class="btn btn-xs btn-success " (click)="addValueToParams(f)"><i class="fa fa-plus"></i></button>
                        <button class="btn btn-xs btn-outline-success " (click)="f.params=colors"><i class="fa fa-plus-square mr-2"></i>Colori</button>
                        <button class="btn btn-xs btn-outline-success " (click)="f.params=months"><i class="fa fa-plus-square mr-2"></i>Mesi dell'anno</button>
                        <button class="btn btn-xs btn-outline-success " (click)="f.params=qualifications"><i class="fa fa-plus-square mr-2"></i>Titoli di studio</button>
                        <button class="btn btn-xs btn-outline-success " (click)="f.params=nations"><i class="fa fa-plus-square mr-2"></i>Stati del mondo</button>
                        <button class="btn btn-xs btn-outline-success " (click)="f.params=italian_regions"><i class="fa fa-plus-square mr-2"></i>Regioni italiani</button>
                        <button class="btn btn-xs btn-outline-success " (click)="f.params=italian_country"><i class="fa fa-plus-square mr-2"></i>Province italiani</button>
                        <button class="btn btn-xs btn-danger " [disabled]="param_selected==''" (click)="removeValueFromParams(f)"><i class="fa fa-trash"></i></button>
                    </div>                                                   
                </div>
                <div class="col-12" *ngSwitchCase="'table'">
                    <small>Dati tabella</small>   
                    <div class="p-1 border">
                        
                        <app-fields [sections]="f.params"></app-fields>
                    </div>                                                    
                </div>
                <div class="col-12" *ngSwitchDefault>
                    <ng-container *ngIf="isArray(f.params) && f.params && f.params.length>0">
                            <small>Parametri</small>
                            <div class="border p-2">
                            <ng-container *ngFor="let s of f.params">
                                <small>
                                    <app-field [force_label]="true"  [field]="s"></app-field>
                                </small>
                            </ng-container>
                        </div>
                    </ng-container>
                </div>
            </ng-container>
            
            <!--<div class="col-lg-12" *ngIf="f.type=='address'">
                <small>Tipologia di default</small>
                <select class="form-control form-control-sm" [(ngModel)]="f.params" >
                    <option *ngFor="let t of type_addresses" value="{{t.id}}">{{t.name}}</option>
                </select>
            </div>-->

            <div class="col-lg-2" *ngIf="sections.length>0">
                <small>Ricercabile <i class="fa fa-exclamation-circle text-gray" title="Il contenuto del campo sarà ricerabile nella lista"></i></small>
                    <select class="form-control form-control-sm" name="{{j}}_{{i}}_searchable" [(ngModel)]="f.searchable">
                    <option value="0">No</option>
                    <option value="1">Si</option>
                </select>
            </div>
            <div class="col-lg-3" *ngIf="sections.length>0">
                <small>Mostra in lista</small>
                <select class="form-control form-control-sm"  name="{{j}}_{{i}}_show_list" [(ngModel)]="f.show_list">
                    <option value="0">No</option>
                    <option value="1">Si</option>
                </select>                                                
            </div>
            <div class="col-lg-4" *ngIf="sections.length>0">
                <small>Cambia sezione in...</small>
                <select class="form-control form-control-sm"  name="{{j}}_{{i}}_id_parent" [(ngModel)]="f.id_parent" (change)="onMoveToSection.emit(f)">
                    <option *ngFor="let s of sections" [ngValue]="s.id">{{s.name}}</option>
                </select>
            </div>
            <div class="col-lg-3">
                <small>Accesso</small>                
                <div class="input-group">
                    <select class="form-control form-control-sm"  name="{{j}}_{{i}}_id_parent" [(ngModel)]="f.access_mode" [class.text-danger]="f.access_mode==''" (ngModelChange)="setAccess(f)">
                        <option value="all">Accessibile a tutti</option>
                        <!-- <option value="read">Sola lettura</option> -->
                        <option value="">Non accessibile</option>
                        <option value="custom">Personalizzato</option>
                        <!--
                        <option value="1">Pubblico</option>
                        <option value="3">Pubblico (solo visione)</option>
                        <option value="2">Privato</option>
                        <option value="0">Non pubblicato</option>
                        -->
                    </select>
                    <div class="input-group-append" *ngIf="f.access_mode=='custom' && isArray(f.access)">
                        <button class="btn btn-sm btn-default" (click)="openAccessModal()"><i class="fa fa-list"></i></button>
                    </div>
                </div>
            </div>                                           
            <div class="col-lg-9" *ngIf="fields.length>0">
                <small>Abilita se è compilato il campo...<span class="float-right">...e il campo è valorizzato con... 
                    <i class="fa fa-exclamation-circle text-gray" title="Se vi sono più valori possibili, separare con ;"></i></span></small>
                <div class="input-group input-group-sm">
                        <select class="form-control form-control-sm" name="{{j}}_{{i}}_condition_enable_fieldname" [(ngModel)]="f.condition_enable_fieldname" >
                    <option value="">Nessuno</option>
                    <option *ngFor="let f2 of fields" value="{{f2.name}}">{{f2.name}}</option>
                </select>
                    <div class="input-group-append input-group-append-sm">
                        <input type="text" class="form-control form-control-sm" name="{{j}}_{{i}}_condition_fieldname_value" [(ngModel)]="f.condition_fieldname_value" >
                    </div>
                </div>
            </div>
            <div class="col-lg-3" *ngIf="customfields.length>0">
                <small>Salva nel campo...</small>
                <select class="form-control form-control-sm"  name="{{j}}_{{i}}_replicate_id_customfield" [(ngModel)]="f.replicate_id_customfield" >
                    <option value="0">Nessuno</option>
                    <option *ngFor="let customfield of customfields " value="{{customfield.id}}">{{customfield.label}} ({{customfield.table}})</option>
                </select>
            </div>
            <!--
            <div class="col-12">
                <small>Note interne</small>
                <textarea type="text" rows="1" onfocus="this.rows=3;" class="form-control form-control-sm"  name="{{j}}_{{i}}_note" [(ngModel)]="f.note" ></textarea>
            </div>
            -->
        </div>
     <!--</div>
   
    <div class="col-lg-2 pr-0 text-right">
        <small *ngIf="f.id" class="text-gray">ID: {{f.id}}</small><br>
        <button class="btn btn-default text-danger btn-xs" (click)="onRemove.emit(f)"><i class="fa fa-trash"  title="Elimina campo"></i></button>
        <button class="btn btn-default text-info btn-xs" (click)="onDuplicate.emit(f)"><i class="fa fa-clone"  title="Dupplica campo"></i></button>
        <button class="btn btn-default btn-xs" (click)="onMoveField.emit({field:f,direction:'up'});"><i class="fas fa-chevron-up"  title="Sposta sopra"></i></button>
        <button class="btn btn-default btn-xs" (click)="onMoveField.emit({field:f,direction:'down'});"><i class="fas fa-chevron-down"   title="Sposta sotto"></i></button>
        
        <button class="btn btn-default btn-xs" *ngIf="!f['expand']" (click)="f['expand']=true"><i class="fas fa-expand-alt"  title="Espandi"></i></button>
        <button class="btn btn-default btn-xs" *ngIf="f['expand']" (click)="f['expand']=false"><i class="fas fa-compress-alt"  title="Comprimi"></i></button>
    </div>

</div>-->


<ng-template #modalAccessList>
      <div class="modal-header">
        Accessi
        <div class="card-tools">
            <button type="button" class="btn btn-tool" (click)="closeAccessModal()" >
              <i class="fas fa-times"></i>
            </button>
        </div>
    </div>
    <div class="modal-body"> 
        <table class="table table-sm">
            <thead>                
                <th>Ruolo</th>
                <th>Permessi</th>
            </thead>
            <tbody>
                <tr *ngFor="let g of f.access">
                    <td>{{g.group}}</td>
                    <td>
                        <select class="form-control form-control-sm" [(ngModel)]="g.permission" >
                            <option value="">Non accessibile</option>
                            <option value="all">Lettura e scrittura</option>
                            <option value="read">Sola lettura</option>
                        </select>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="modal-footer">        
        <button class="btn btn-outline-secondary btn-block" (click)="closeAccessModal()">Chiudi</button>
    </div>
</ng-template>